(function() {
    //Attach the page nav bar to the sticky header
    const pageNavContainer = document.createElement('div')
    pageNavContainer.className = 'page-nav-animate__container'
    const headerContainer = document.querySelector('sticky-header')
    if(!headerContainer) return
    headerContainer.appendChild(pageNavContainer)
    pageNavContainer.appendChild(document.querySelector('#PageNavTemplate').content.cloneNode(true))

    //An intersection observer triggers the nav bar scrolls in or scrolls out
    const observer = new IntersectionObserver((entries) => {
      if(entries[0].boundingClientRect.top < 0) {
        pageNavContainer.classList.remove('scroll-out')
        pageNavContainer.classList.add('scroll-in')
      } else if(entries[0].boundingClientRect.top > 0 && pageNavContainer.classList.contains('scroll-in')) {
        pageNavContainer.classList.remove('scroll-in')
        pageNavContainer.classList.add('scroll-out')
      }
    })
    observer.observe(document.querySelector('.page-nav-bar__trigger'))

    // An intersection observer for highlighting the nav label of current intersecting section
    const pageSectionLabelsContainer = document.querySelector('.page-section-labels__container')
    const labelBtns = pageSectionLabelsContainer.querySelectorAll('button[data-section]')
    const sectionObserver = new IntersectionObserver((entries) => {
      if(!entries[0].isIntersecting) return
      // if(!entries[0].isIntersecting && entries[0].target.className === 'bottom-label') {
      //   if(entries[0].boundingClientRect.top > 0) return
      //   // Only execute when scrolling down
      //   labelBtns.forEach(btn => btn.className='')
      //   // console.log('Running')
      //   return
      // }
      // console.log(entries[0])
      
      // Highlight Label
      const currentLabel = entries[0].target.dataset.pageNavLabel
      if(pageSectionLabelsContainer.querySelector(`[data-section=${currentLabel}]`).className === 'active') return

      labelBtns.forEach(btn => btn.className='')
      const currentLabelBtn = pageSectionLabelsContainer.querySelector(`[data-section=${currentLabel}]`)
      currentLabelBtn.className = 'active'

      // Scrolling the button label of current section into view
      if(pageSectionLabelsContainer.scrollWidth <= pageSectionLabelsContainer.clientWidth) return
      pageSectionLabelsContainer.scrollTo({top: 0, left: currentLabelBtn.offsetLeft - pageSectionLabelsContainer.offsetLeft - 7, behavior: 'smooth'})
    }, {threshold: 1})

    document.querySelectorAll('div[data-page-nav-label]').forEach(label => {
      sectionObserver.observe(label)
    })
    
    //Add click event listener to the page nav label container
    const navLabelsContainer = document.querySelector('.page-nav-labels__container')
    if(!navLabelsContainer) return
    navLabelsContainer.addEventListener('click', e => {
      if(!e.target.closest('button[data-section]')) return
      goToTargetSection(e.target.closest('button[data-section]'))
    })

    //The click event listener callback
    function goToTargetSection(navButton) {
      if(navButton.dataset.section === 'top') {
        scrollTo({top: 0, behavior: 'smooth'})
        return
      }

      const sectionName = navButton.dataset.section
      if(!sectionName) return

      const targetSection = document.querySelector(`[data-page-nav-label=${sectionName}]`)
      if(targetSection) targetSection.scrollIntoView({behavior: 'smooth'})
    }
  })()